// extracted by mini-css-extract-plugin
module.exports = {"StatusSpinner":"supply-and-scheduling__SyncStatus__StatusSpinner","StatusLabel":"supply-and-scheduling__SyncStatus__StatusLabel"};